import { CheckIcon } from 'lucide-react-native';
import React from 'react';
import { type GestureResponderEvent } from 'react-native';
import { View } from 'tamagui';

import { hitSlop } from '../componentHelpers';
import { Icon } from '../icons/Icon';

export interface CircularSelectionIndicatorProps {
    selected: boolean;
    disabled?: boolean;
    onPress?: (e: GestureResponderEvent) => void;
    testID?: string;
    borderVisible?: boolean;
}

export const CircularSelectionIndicator = ({
    selected,
    disabled = false,
    onPress,
    testID,
    borderVisible = false,
}: CircularSelectionIndicatorProps) => {
    const isInteractive = onPress != null && !disabled;

    return (
        <View
            testID={testID}
            onPress={onPress}
            disabled={disabled}
            width={40}
            height={40}
            alignItems="center"
            justifyContent="center"
            cursor={isInteractive ? 'pointer' : 'default'}
            pointerEvents={isInteractive ? 'auto' : 'none'}
            pressStyle={
                !disabled && {
                    opacity: 0.7,
                }
            }
            {...hitSlop(4)}
        >
            <View
                width={24}
                height={24}
                borderRadius={9999}
                alignItems="center"
                justifyContent="center"
                backgroundColor={selected ? '$green800' : '$white'}
                borderWidth={!selected && borderVisible ? 1 : 0}
                borderColor="$gray600"
            >
                {selected ? (
                    <Icon icon={CheckIcon} size={16} color="$white" />
                ) : null}
            </View>
        </View>
    );
};
